import { z } from 'zod/v4';
import { joi } from './index';

import { TaggableEntityType } from '@payaca/types/tagTypes';

export const booleanSchema = joi
  .boolean()
  .required()
  .truthy('t', 'yes', 'y', '1')
  .falsy('f', 'no', 'n', '0');

export const integerSchema = joi.number().integer().required();

export const floatSchema = joi.number().required();

export const stringSchema = joi.string().allow('').required();

export const uriSchema = joi.string().uri().required();

/**
 * Integer IDs are used to identify entities in the database by their
 * primary key (id), when the primary key is of type INTEGER
 * (and not BIGINTEGER or VARCHAR).
 *
 * Ideally we wouldn't use these as public-facing IDs, because leaking
 * primary keys outside of the database/backend (e.g. in URLs, or via APIs)
 * constitutes a security risk as well as a privacy risk.
 * It also hampers our ability to migrate or shard our database.
 *
 * However, we do use them for the time being, and we need to validate them,
 * hence the existence of this Joi schema.
 */
export const integerIdSchema = joi.number().integer().positive();

/**
 * With the introduction of Service Plans, we have started to use opaque string
 * identifiers (nanoids) as public IDs.
 */
export const publicIdSchema = joi.string();

export const taggableEntityTypeSchema = joi
  .string()
  .valid(...Object.values(TaggableEntityType));

export const expectedSignatoriesInputSchema = z
  .array(
    z.object({
      role: z.literal('customer'),
      identifier: z.string().min(1).max(255),
    })
  )
  .max(1)
  .nullish();
